import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MenuComponent } from './menu/menu.component';
import { InicioComponent } from './inicio/inicio.component';
import { FooterComponent } from './footer/footer.component';
import { MenuLoginComponent } from './menu-login/menu-login.component';
import { jqxMenuModule } from 'jqwidgets-ng/jqxmenu';
import { NotFoundComponent } from './not-found/not-found.component';


@NgModule({
    declarations:[
        MenuComponent,
        InicioComponent,
        FooterComponent,
        MenuLoginComponent,
        NotFoundComponent
    ],
    imports:[
        CommonModule,
        RouterModule,
        jqxMenuModule
    ],
    exports:[
        MenuComponent,
        InicioComponent,
        FooterComponent,
        NotFoundComponent
    ]
})
export class NavegacaoModule{}